/*
  Breakpoints at which the Home feed grid changes column count.
  > fullscreenMin = 4 grid;
  > desktopMin = 3 grid;
  > tabletMin = 2 grid;
  < tabletMin = 1 grid;
  These should be updated if we change our breakpoint sizes.
*/

const COLUMN_BREAKPOINTS = {
  fullscreenMin: 1440,
  desktopMin: 980,
  tabletMin: 768,
};

const getColumnCount = (columnCount) => {
  if (typeof window !== 'undefined') {
    const { innerWidth } = window;
    let count = 4;
    if (innerWidth < COLUMN_BREAKPOINTS.tabletMin) {
      count = 1;
    } else if (innerWidth < COLUMN_BREAKPOINTS.desktopsmallMin) {
      count = 2;
    } else if (innerWidth < COLUMN_BREAKPOINTS.fullscreenMin) {
      count = 3;
    }

    return count;
  }

  return columnCount;
};

export default getColumnCount;
